module.exports = {
	"date": "du 21.01 au 24.01.2025",
	"title": "Assiette du jour à 18.-",
	"info": "Toutes les assiettes sont accompagnées d'une petite salade",
	"menu": [
		{
			"day": "Au choix:",
			"dish": "Fusilli au thon"
		},
		{
			"day": "--",
			"dish": "Rigatoni aux aubergines"
		},
		{
			"day": "--",
			"dish": "Penne jambon et safran"
		},
		{
			"day": "--",
			"dish": "Risotto aux 4 fromages"
		}
	]
};


//////////////////
// WEBPACK FOOTER
// ./src/data/daydish.json
// module id = 20
// module chunks = 0